import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Injectable, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RestServiceAbstract } from '../../../core/base/rest.service.abstract';
import { ResponseModel } from '../../../core/base/response.model';
import {EvaluationData} from "../models";

@Injectable({
  providedIn: 'root',
})
export class EvaluationRestService extends RestServiceAbstract {
  private readonly destroyRef = inject(DestroyRef);

  public loadEvaluationData(idf: string, year: number, month: number): Observable<ResponseModel> {
    return this.get(`/${this.USERMANAGEMENT}/evaluations/${idf}/${year}/${month}`).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: object) => new ResponseModel<EvaluationData>(data)),
      catchError((err: unknown) => throwError(() => err))
    );
  }
}
